import { InjectionToken, Provider } from '@angular/core';
import { environment } from '@environments/environment';
import { OemApiMockService } from '@mocks/oem-api-mock.service';
import { OemApiService } from '../oem-api.service';
import { OemRepository } from '../oem.repository';

export const HTTP_OEM_SERVICE = new InjectionToken<OemRepository>('OemRepository');

export const OEM_API_PROVIDER: Provider = {
    provide: HTTP_OEM_SERVICE,
    useClass: environment.useMocks && environment.useMocks.oem ? OemApiMockService : OemApiService,
};
